/* tslint:disable */
/* eslint-disable */
/**
 * Common
 * 共通API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * コストコ店舗
 * @export
 * @interface CostcoStore
 */
export interface CostcoStore {
    /**
     * 
     * @type {string}
     * @memberof CostcoStore
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CostcoStore
     */
    name: string;
}

/**
 * Check if a given object implements the CostcoStore interface.
 */
export function instanceOfCostcoStore(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CostcoStoreFromJSON(json: any): CostcoStore {
    return CostcoStoreFromJSONTyped(json, false);
}

export function CostcoStoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostcoStore {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function CostcoStoreToJSON(value?: CostcoStore | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

